// Example locale file for English, give this to your locale team to translate

export const AG_GRID_LOCALE_ES = {
    // Set Filter
    selectAll: '(Seleccionar todo)',
    selectAllSearchResults: '(Seleccione todos los resultados de búsqueda)',
    searchOoo: 'Búsqueda...',
    blanks: '(Espacios en blanco)',
    noMatches: 'No hay coincidencias',

    // Number Filter & Text Filter
    filterOoo: 'Filtrar...',
    equals: 'Igual',
    notEqual: 'No es igual',
    blank: 'En blanco',
    notBlank: 'No en blanco',
    empty: 'Elige uno',

    // Number Filter
    lessThan: 'Menos que',
    greaterThan: 'Mas grande que',
    lessThanOrEqual: 'Menor o igual',
    greaterThanOrEqual: 'Mayor que o igual',
    inRange: 'En el rango',
    inRangeStart: 'Desde',
    inRangeEnd: 'Hasta',

    // Text Filter
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Comienza con',
    endsWith: 'Termina con',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'Y',
    orCondition: 'O',

    // Filter Buttons
    applyFilter: 'Aplicar',
    resetFilter: 'Reiniciar',
    clearFilter: 'Limpiar',
    cancelFilter: 'Cancelar',

    // Filter Titles
    textFilter: 'Filtro de texto',
    numberFilter: 'Filtro de número',
    dateFilter: 'Filtro de fecha',
    setFilter: 'Establecer filtro',

    // Side Bar
    columns: 'Columnas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Modo de pivote',
    groups: 'Grupos de filas',
    rowGroupColumnsEmptyMessage: 'Arrastre aquí para establecer grupos de filas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arrastre aquí para agregar',
    pivots: 'Etiquetas de columna',
    pivotColumnsEmptyMessage: 'Arrastre aquí para establecer etiquetas de columna',

    // Header of the Default Group Column
    group: 'Grupo',

    // Row Drag
    rowDragRow: 'fila',
    rowDragRows:'filas',

    // Other
    loadingOoo: 'Cargando...',
    noRowsToShow: 'No hay filas para mostrar',
    enabled: 'Activado',

    // Menu
    pinColumn: 'Columna anclada',
    pinLeft: 'Anclar a la izquierda',
    pinRight: 'Anclar a la derecha',
    noPin: 'No anclado',
    valueAggregation: 'Agregación de valor',
    autosizeThiscolumn: 'Tamaño automático de esta columna',
    autosizeAllColumns: 'Tamaño automático de todas las columnas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    addToValues: 'Agregar ${variable} a los valores',
    removeFromValues: 'Eliminar ${variable} de los valores',
    addToLabels: 'Agregar ${variable} a las etiquetas',
    removeFromLabels: 'Eliminar ${variable} de las etiquetas',
    resetColumns: 'Restablecer columnas',
    expandAll: 'Expandir todo',
    collapseAll: 'Cierra todo',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copiar con encabezados',
    copyWithGroupHeaders: 'Copiar con encabezados de grupo',
    paste: 'Pegar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportar CSV',
    excelExport: 'Exportare Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Suma',
    min: 'Min',
    max: 'Max',
    none: 'Ninguno',
    count: 'Contar',
    avg: 'Promedio',
    filteredRows: 'Filtrado',
    selectedRows: 'Seleccionado',
    totalRows: 'Filas totales',
    totalAndFilteredRows: 'Filas',
    more: 'Más',
    to: 'a',
    of: 'de',
    page: 'Página',
    nextPage: 'Siguiente página',
    lastPage: 'Última página',
    firstPage: 'Primera página',
    previousPage: 'Pagina anterior',

    // Pivoting
    pivotColumnGroupTotals: 'Total',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Gráfico dinámico y modo de pivote',
    pivotChart: 'Gráfico dinámico',
    chartRange: 'Rango de gráfico',

    columnChart: 'Columna',
    groupedColumn: 'Agrupados',
    stackedColumn: 'Apilado',
    normalizedColumn: '100% apilado',

    barChart: 'Barra',
    groupedBar: 'Agrupados',
    stackedBar: 'Apilado',
    normalizedBar: '100% apilado',

    pieChart: 'Tarta',
    pie: 'Tarta',
    doughnut: 'Rosquilla',

    line: 'Linee',

    xyChart: 'X Y (Dispersión)',
    scatter: 'Dispersión',
    bubble: 'Burbuja',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Apilado',
    normalizedArea: '100% apilado',

    histogramChart: 'Histograma',
    histogramFrequency: "Frecuencia",

    combinationChart: 'Combinación',
    columnLineCombo: 'Columna y línea',
    AreaColumnCombo: 'Área y Columna',

    // Charts
    pivotChartTitle: 'Gráfico dinámico',
    rangeChartTitle: 'Gráfico de rango',
    settings: 'Ajustes',
    data: 'Data',
    format: 'Formato',
    categories: 'Categorias',
    defaultCategory: '(Ninguno)',
    series: 'Series',
    xyValues: 'Valores X Y',
    paired: 'Modo emparejado',
    axis: 'Eje',
    navigator: 'Navegador',
    color: 'Color',
    thickness: 'Espesor',
    xType: 'Tipo X',
    automatic: 'Automática',
    category: 'Categoría',
    number: 'Número',
    time: 'Tiempo',
    autoRotate: 'Auto rotar',
    xRotation: 'Rotación X',
    yRotation: 'Rotación Y',
    ticks: 'Ticks',
    width: 'Ancho',
    height: 'Altura',
    length: 'Longitud',
    padding: 'Relleno',
    spacing: 'Espaciado',
    chart: 'Cuadro',
    title: 'Título',
    titlePlaceholder: 'Título del gráfico: haga doble clic para editar',
    background: 'Fondo',
    font: 'Fuente',
    top: 'Arriba',
    right: 'Derecha',
    bottom: 'Abajo',
    left: 'Izquierda',
    labels: 'Etiquetas',
    size: 'Tamaño',
    minSize: 'Talla minima',
    maxSize: 'Talla máxima',
    legend: 'Leyenda',
    position: 'Posición',
    markerSize: 'Tamaño del marcador',
    markerStroke: 'Trazo de marcador',
    markerPadding: 'Relleno de marcador',
    itemSpacing: 'Espaciado de elementos',
    itemPaddingX: 'Artículo relleno X',
    itemPaddingY: 'Artículo relleno Y',
    layoutHorizontalSpacing: 'Espaciado horizontal',
    layoutVerticalSpacing: 'Espaciado vertical',
    strokeWidth: 'Anchura del trazo',
    lineDash: 'Guión de línea',
    offset: 'Compensar',
    offsets: 'Compensaciones',
    tooltips: 'Información sobre herramientas',
    callout: 'Gritar',
    markers: 'Marcadores',
    shadow: 'Sombra',
    blur: 'Difuminar',
    xOffset: 'Desplazamiento X',
    yOffset: 'Desplazamiento Y',
    lineWidth: 'Ancho de línea',
    normal: 'Normal',
    bold: 'Negrita',
    italic: 'Cursiva',
    boldItalic: 'Negrita cursiva',
    predefined: 'Predefinido',
    fillOpacity: 'Opacidad de relleno',
    strokeOpacity: 'Opacidad de línea',
    histogramBinCount: 'Recuento de contenedores',
    columnGroup: 'Columna',
    barGroup: 'Barra',
    pieGroup: 'Tarta',
    lineGroup: 'Linea',
    scatterGroup: 'X Y (Dispersión)',
    areaGroup: 'Area',
    histogramGroup: 'Histograma',
    combinationGroup: 'Combinación',
    groupedColumnTooltip: 'Agrupados',
    stackedColumnTooltip: 'Apilado',
    normalizedColumnTooltip: '100% Apilado',
    groupedBarTooltip: 'Agrupados',
    stackedBarTooltip: 'Apilado',
    normalizedBarTooltip: '100% Apilado',
    pieTooltip: 'Tarta',
    doughnutTooltip: 'Rosquilla',
    lineTooltip: 'Linea',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Apilado',
    normalizedAreaTooltip: '100% Apilado',
    scatterTooltip: 'Dispersión',
    bubbleTooltip: 'Burbuja',
    histogramTooltip: 'Histograma',
    columnLineComboTooltip: 'Columna y línea',
    areaColumnComboTooltip: 'Área y Columna',
    customComboTooltip: 'Combinación personalizada',
    noDataToChart: 'No hay datos disponibles para ser graficados.',
    pivotChartRequiresPivotMode: 'El gráfico dinámico requiere que el modo pivote esté habilitado.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Vinculado a la cuadrícula',
    chartUnlinkToolbarTooltip: 'Desvinculado de la cuadrícula',
    chartDownloadToolbarTooltip: 'Descargar gráfico',
    seriesChartType: 'Tipo de gráfico de serie',
    seriesType: 'Tipo de serie',
    secondaryAxis: 'Eje secundario',

    // ARIA
    ariaChecked: 'Comprobado',
    ariaColumn: 'Columna',
    ariaColumnGroup: 'Grupo de columnas',
    ariaColumnList: 'Lista de columnas',
    ariaColumnSelectAll: 'Alternar seleccionar todas las columnas',
    ariaDateFilterInput: 'Entrada de filtro de fecha',
    ariaDefaultListName: 'Lista',
    ariaFilterColumnsInput: 'Entrada de columnas de filtro',
    ariaFilterFromValue: 'Filtrar por valor',
    ariaFilterInput: 'Entrada de filtro',
    ariaFilterList: 'Lista de filtros',
    ariaFilterToValue: 'Filtrar por valor',
    ariaFilterValue: 'Valor de filtro',
    ariaFilteringOperator: 'Operador de filtrado',
    ariaHidden: 'oculto',
    ariaIndeterminate:'indeterminado',
    ariaInputEditor: 'Editor de entrada',
    ariaMenuColumn: 'Presione CTRL ENTER para abrir el menú de columnas.',
    ariaRowDeselect: 'Presiona ESPACIO para anular la selección de esta fila',
    ariaRowSelectAll: 'Presione Espacio para alternar la selección de todas las filas',
    ariaRowToggleSelection: 'Presione la barra espaciadora para alternar la selección de filas',
    ariaRowSelect: 'Presiona ESPACIO para seleccionar esta fila',
    ariaSearch: 'Búsqueda',
    ariaSortableColumn: 'Presione ENTER para ordenar',
    ariaToggleVisibility: 'Presiona ESPACIO para alternar la visibilidad',
    ariaUnchecked: 'No comprobado',
    ariaVisible: 'visible',
    ariaSearchFilterValues: 'Valores de filtro de búsqueda',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Grupos de filas',
    ariaValuesDropZonePanelLabel: 'Valores',
    ariaPivotDropZonePanelLabel: 'Etiquetas de columna',
    ariaDropZoneColumnComponentDescription: 'Presione ELIMINAR para eliminar',
    ariaDropZoneColumnValueItemDescription: 'Presione ENTER para cambiar el tipo de agregación',
    ariaDropZoneColumnGroupItemDescription: 'Presione ENTER para ordenar',
    // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeperator}{column name}
    ariaDropZoneColumnComponentAggFuncSeperator: ' de ',
    ariaDropZoneColumnComponentSortAscending: 'ascendente',
    ariaDropZoneColumnComponentSortDescending: 'descendiendo',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Menú de columna',
    ariaLabelCellEditor: 'Editor celular',
    ariaLabelDialog: 'Diálogo',
    ariaLabelSelectField: 'Seleccionar campo',
    ariaLabelTooltip: 'Información sobre herramientas',
    ariaLabelContextMenu: 'Menú de contexto',
    ariaLabelSubMenu: 'Submenú',
    ariaLabelAggregationFunction: 'Función de agregación',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.'

}